<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom mb-5">
        <div class="modal inmodal" id="detailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <form #attemptForm="ngForm">
                <div class="modal-dialog modal-xl" style="overflow-y: initial !important">
                    <div class="modal-content animated flipInY">
                        <div class="modal-header">
                            <h4 class="modal-title">Fees Request Details</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closeForm()"><span
                                    aria-hidden="true">&times;</span>
                                <span class="sr-only">Close</span></button>
                        </div>
                        <div class="modal-body modal_box" style="height: 80vh;overflow-y: auto;">
                        <div class="row">
                            <div class="col-md-12">
                                <label> College name : </label><b> {{SchoolName}}</b>
                            </div>
                            <div class="col-md-12">
                                <label> Medium : </label><b> {{Medium}}</b>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label> Academic year : </label><b> {{AcademicYear}}</b>
                            </div>
                            <div class="col-md-3">
                                <label> Course : </label><b> {{Standard}}</b>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table id="example" class="table table-striped table-bordered" style="width:100%">
                                    <thead>
                                        <tr>
                                            <th class="pointer" scope="col">Fees Head</th>
                                            <th class="pointer" scope="col">Fees Amount (Current Amount)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let r of FeesIncreaseDetail ;let i = index">
                                            <td>
                                                <p>{{r.FeesHead}}</p>
                                            </td>
                                            <td>
                                                <p>{{r.FeesAmount}}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Total
                                            </td>
                                            <td>
                                                {{totalAmt}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </form>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12 py-2">
            <div class="col-mb-4" style="text-align: left">
                <h4> Allocated Request List {{schoolname}}</h4>
            </div>
        </div>
    </div>

    <div class="card row">
        <div class="col-lg-12 p-4">
            <div *ngIf="FeesIncreaseList != undefined && FeesIncreaseList.length > 0">
                <div class="card col-mb-6">
                    <div class="card-header py-3">
                        <input type="text" class="form-control bg-white border-0 small" placeholder="Search for..."
                            [(ngModel)]="searchtext" aria-label="Search" aria-describedby="basic-addon2"
                            (keyup)="setpage()" />
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                        <thead>
                            <tr>
                                <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr No. </th>
                                <th class="pointer" scope="col" (click)="sortBy('RequestDate')">Request Date </th>
                                <th class="pointer" scope="col" (click)="sortBy('SchoolName')">College Name</th>
                                <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                <th class="pointer" scope="col" (click)="sortBy('AcademicYear')">Academic year</th>
                                <th class="pointer" scope="col" (click)="sortBy('Standard')">Course</th>
                                <th class="pointer" scope="col" (click)="sortBy('CourseYear')">Course year</th>
                                <th class="pointer" scope="col" (click)="sortBy('TotalAmount')">Total amount</th>
                                <th class="pointer" scope="col" (click)="sortBy('Remark')">Remark</th>
                                <th class="pointer" scope="col">View Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let r of FeesIncreaseList | filter:searchtext | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                <td>
                                    <p>{{r.SrNo}}</p>
                                </td>
                                <td>
                                    <p>{{r.RequestDate}}</p>
                                </td>
                                <td>
                                    <p>{{r.SchoolName}}</p>
                                </td>
                                <td>
                                    <p>{{r.Medium}}</p>
                                </td>
                                <td>
                                    <p>{{r.AcademicYear}}</p>
                                </td>
                                <td>
                                    <p>{{r.Standard}}</p>
                                </td>
                                <td>
                                    <p>{{r.CourseYear}}</p>
                                </td>
                                <td>
                                    <p>{{r.TotalAmount}}</p>
                                </td>
                                <td>
                                    <p>{{r.Remark}}</p>
                                </td>
                                <td style="white-space: nowrap;">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-success rmb_10"
                                            (click)="viewFeesDetail(i)">View</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer pb-3 pt-3" align="center">
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-login custom-footer">
    <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
    <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
</div>
</div>